import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "../content/site";
import { Reveal } from "../components/Reveal";

export default function LegalPage({ kind }) {
  const doc = LEGAL[kind];
  useEffect(() => {
    document.title = `${doc.title} — WebStudios`;
    window.scrollTo(0, 0);
    return () => { document.title = "WebStudios — Website Design, Hosting & Maintenance UK"; };
  }, [doc]);

  return (
    <div className="min-h-screen bg-white text-slate-700">
      <header className="border-b border-slate-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 flex items-center justify-between">
          <a href="/" data-testid="legal-logo" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="WebStudios — website design, hosting and maintenance" className="h-11 w-auto object-contain" />
          </a>
          <a href="/" data-testid="legal-back" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 transition-colors duration-200">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </a>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16 lg:py-24" data-testid={`legal-${kind}-page`}>
        <Reveal>
          <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#0055FF] mb-4">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-slate-900">{doc.title}</h1>
          <p className="mt-3 font-mono2 text-xs text-slate-400">{doc.updated}</p>
          <p className="mt-8 text-base text-slate-600 leading-relaxed">{doc.intro}</p>
        </Reveal>
        {doc.sections.map((s, i) => (
          <Reveal key={s.h} delay={0.05 * i}>
            <section className="mt-12" data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-2xl font-semibold tracking-tight text-slate-900 flex items-baseline gap-3">
                <span className="font-mono2 text-sm text-cyan-600">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              <div className="mt-4 space-y-3">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm sm:text-base text-slate-600 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
        <Reveal delay={0.1}>
          <div className="mt-16 bg-[#F0F4FF] border border-[#0055FF]/10 rounded-2xl p-6">
            <p className="text-sm text-slate-600">
              Questions about this policy? Email{" "}
              <a href="mailto:webstudios.co.uk@gmail.com" data-testid="legal-email-link" className="text-[#0055FF] hover:underline">webstudios.co.uk@gmail.com</a>
              {" "}or WhatsApp <span className="text-slate-900 font-medium">07440 752224</span>.
            </p>
          </div>
        </Reveal>
      </main>
    </div>
  );
}
